export default {
  message: {
    longPressSaveTips: 'Long press to save the picture',
    noUser:'Please enter your contact name/phone number/verification code. ',
    bookingSuccess:'Submission success',
    bookingFailed:'Submission failure',
    phoneNumInvalid:'Please enter a valid cell phone number!',
  },
  placeholder: {
    enter: 'Please type in your favorite brand'
  },
  activityInfo: {
    detail:'Intro'
  },
  fullScreenPhoto: {
    showPic:'Display original picture ',
    downloading:'Downloading',
    fileName:'File Name',
    fileSize:'File Size',
    category:'Category',
    authorName:'Photographer',
  },
  functionBar:{
    all:'All',
    newest: 'Newest',
    hot: 'Hot',
    category:'Photo',
    video:'Video',
    arrange:'Sort',
    merge:'Merge',

    video:'Video',
  },
  imagewall:{
    cancel:'Cancel',
    merge:'Merge',
    longPressSaveTips:'Long press to save the picture',
    sweepAndShareTips:'Scan the qrcode to share the album',
    product:'Camfi cloud album',
    bookingTitle:'Contact the photographer',
    bookingContacts:'Your name (required)',
    bookingPhoneNum:'Phone number (required)',
    bookingSmscode:'Verification code (required)',
    bookingGetSmscode:'Send',
    bookingRetrySmscode:'Seconds later',
    bookingCompany:'Company Name (optional)',
    bookingDetail:'Other requests, such as time, place, scale of activities, etc. (optional) ',
    bookingSubmit:'Submit',

    selfieTitle:'Selfie selection',
    selfieTipsInit1:'Please upload a single frontal',
    selfieTipsInit2:'Quickly find photos in the album',
    selfieTipsUploading:'Being identified, please wait...',
    selfieTipsFailed:'Identification failure',
    selfieUpload:'Upload photos',
    selfieReupload:'Re-upload photos',
  },
  welcome:{
    into:'Enter'
  }
}